import React from 'react';

//layout
import { OuterWrapper, ComponentWrapper } from '../../operator/OperatorShared';

//components
import AppAccessDeniedService from './AppAccessDeniedService';
import AccessDeniedComponent from './AccessDeniedComponent';

const AppAccessDenied = (props) => {
  const { strings } = AppAccessDeniedService;
  return (
    <OuterWrapper title={strings.deniedTitle} internal path='/'>
      <ComponentWrapper title={strings.pageTitle}>
        <AccessDeniedComponent enterprise />
      </ComponentWrapper>
    </OuterWrapper>
  );
};

export default AppAccessDenied;
